// src/api/axios.js

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // Global aktiv – alle Requests erhalten automatisch Credentials
  headers: {
    'X-API-KEY': process.env.REACT_APP_API_KEY,
  },
  validateStatus: status => (status >= 200 && status < 300) || status === 401,
});

// Token Refresh
export const refreshToken = async () => {
  try {
    const response = await api.post('refresh.php', {}, { withCredentials: true });
    return response.data?.access_token ? response : { data: null };
  } catch (error) {
    return error.response?.status === 401 ? { data: null } : Promise.reject(error);
  }
};

// Authentication Functions
export const registerUser = async userData =>
  api.post('register.php', userData, { withCredentials: true });

export const forgotPassword = async email =>
  api.post('user/forgot_password.php', { email }, { withCredentials: true });

export const resetPassword = async resetData =>
  api.post('user/reset_password.php', resetData, { withCredentials: true });


export const loginUser = async loginData =>
  api.post('login.php', loginData, { withCredentials: true });

export const logoutUser = async () => {
  try {
    await api.post('logout.php', {}, { withCredentials: true });
  } catch (error) {
    //
  }
  sessionStorage.clear();
  window.location.href = '/';
};

// User Settings
export const updatePassword = async (currentPassword, newPassword) =>
  api.post('user/update_password.php', { currentPassword, newPassword }, { withCredentials: true });

export const updateEmail = async (currentPassword, newEmail) =>
  api.post('user/update_email.php', { currentPassword, newEmail }, { withCredentials: true });

export const toggleNewsletter = async newsletter =>
  api.post('user/update_newsletter.php', { newsletter }, { withCredentials: true });

export const getUserInfo = async () => api.get('user/get_user.php', { withCredentials: true });

// News API
export const getNews = async () =>
  api.get('news/get_all.php', { withCredentials: true });

export const getAdminNews = async () =>
  api.get('news/get_admin.php', { withCredentials: true });

export const createNews = async newsData =>
  api.post('news/create.php', newsData, { withCredentials: true });

export const updateNews = async newsData =>
  api.put('news/update.php', newsData, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

export const deleteNews = async id =>
  api.delete('news/delete.php', { data: { id }, withCredentials: true });

export const uploadNewsImage = async file => {
  const formData = new FormData();
  formData.append('image', file);
  return api.post('news/upload_image.php', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
  });
};
export const getAvailableImages = async () =>
  api.get('list_news_images.php', { headers: { Accept: 'application/json' }, withCredentials: true });

// Coupon API
export const getCoupons = async () =>
  api.get('coupons/get_coupons.php', { withCredentials: true });

export const createCoupon = async couponData =>
  api.post('coupons/create_coupon.php', couponData, { withCredentials: true });

export const deleteCoupon = async id =>
  api.post('coupons/delete_coupon.php', { id }, { withCredentials: true });

// Shop API Endpoints
export const getShopItems = async () =>
  api.get('shop/get_all.php', { withCredentials: true });

export const createShopItem = async itemData =>
  api.post('shop/create.php', itemData, { withCredentials: true });

export const updateShopItem = async itemData =>
  api.put('shop/update.php', itemData, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

export const getPurchaseShopItems = async () =>
  api.get('shop/get_purchase_shop_item.php', { withCredentials: true });

export const purchaseItem = async purchaseData =>
  api.post('shop/purchase.php', purchaseData, { withCredentials: true });

// Payment API Endpoints
export const getArcaniumPurchase = async () =>
  api.get('payment/get_purchase_arcanium.php', { withCredentials: true });

// Vote API Endpoints
export const getUserVotes = async () =>
  api.get('vote/get_user_votes.php', { withCredentials: true });

export const postVotePoints = async (voteSite, userId) =>
  api.post('vote/post_vote_points.php', { vote_site: voteSite, user_id: userId }, { withCredentials: true });

// Ruft das Player Ranking ab
export const getPlayerRanking = async (sv = 'hybrid') =>
  api.get('ranking/get_player_ranking.php', {params: { sv }, withCredentials: true });

export const getPlayerRankingTop10 = async (sv = 'hybrid') =>
  api.get('ranking/get_player_ranking_top10.php', { params: { sv }, withCredentials: true });

// Ruft das Monster Kill Ranking ab
export const getMonsterKillRanking = async (sv = 'hybrid') =>
  api.get('ranking/get_monster_kill_ranking.php', {params: { sv }, withCredentials: true });

// Ruft das Player Kill Ranking ab
export const getPlayerKillRanking = async (sv = 'hybrid') =>
  api.get('ranking/get_player_kill_ranking.php', {params: { sv }, withCredentials: true });

// Ruft das Guild Ranking ab
export const getGuildRanking = async (sv = 'hybrid') =>
  api.get('ranking/get_guild_ranking.php', {params: { sv }, withCredentials: true });

// Ruft Player Online Count ab
export const getServerStatus = async (sv = 'hybrid') =>
  api.get('server_status.php', {params: { sv }, withCredentials: true });

export const getActiveServers = async () =>
  api.get('servers/list.php', { withCredentials: true }); // liefert nur is_active=1

// Ruft die Lucky Wheel Items ab
export const getAllLuckyWheel = async () =>
  api.get('event/get_all_lucky_wheel.php', { withCredentials: true });

export const spinLuckyWheel = async (sv = 'hybrid') =>
  api.post('event/spin_lucky_wheel.php', {params: { sv }, withCredentials: true });

export const getLuckyWheelNextSpinTime = async () =>
  api.get('event/get_next_spint_time.php', { withCredentials: true });


export const getAllCharacters = async (sv = 'hybrid') =>
  api.get('character/get_all_character.php',  {params: { sv }, withCredentials: true });



// Redeem Coupon
export const redeemCoupon = async (couponCode) => {
  try {
    const response = await api.post('event/redeem_coupon.php', { couponCode }, { withCredentials: true });
    return response;
  } catch (error) {
    return error.response?.status === 401 ? { data: null } : Promise.reject(error);
  }
};



// Axios Interceptor for Automatic Logout on 401 and handling rate limit (429)
api.interceptors.response.use(
  response => response,
  async error => {
    if (error.response) {
      if (error.response.status === 401) {
        await logoutUser();
      } else if (error.response.status === 429) {
        //alert('Too many requests. Please wait a minute and try again.');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
